import React from 'react'

// Libs
import { useHistory } from 'react-router-dom'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import moment from 'moment'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { toDateKey, calculateAccuracy } from '../../../utils/accuracy'

// Material UI
import { makeStyles } from '@material-ui/styles'
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button
} from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'

// Styles
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(4)
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 850
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}))

function getDayMetrics(day, inputsByDate) {
  const input = inputsByDate ? inputsByDate[toDateKey(day.date)] : null
  const erpSales = input?.total?.sales ?? 0
  const total = day.success + day.fail
  const conversion = total > 0 ? (day.success / total) * 100 : 0

  return {
    date: moment(day.date).format('DD/MMMM - dddd'),
    services: day.events.length,
    conversion: conversion.toFixed(2),
    accuracy: calculateAccuracy(day.success, erpSales, input != null)
  }
}

export default function DaysTable({
  min,
  className,
  handleSelectDay,
  storeId,
  days,
  inputsByDate,
  onPageChange = page => alert(`onPageChange not defined (${page})`),
  onChangeRows,
  metadata,
  ...rest
}) {
  const classes = useStyles()

  const history = useHistory()

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Data</TableCell>
                  <TableCell>Atendimentos</TableCell>
                  <TableCell>Taxa de conversão</TableCell>
                  <TableCell>Taxa de acurácia</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {days && metadata && metadata.pagination?.totalCount > 0 ? (
                  days
                    .slice(0, min ? 5 : metadata.pagination.limit)
                    .map(day => {
                      const metrics = getDayMetrics(day, inputsByDate)

                      return (
                        <TableRow
                          onClick={() => handleSelectDay(day._id, day.date)}
                          className={classes.tableRow}
                          hover
                          key={day._id}
                          selected={false}
                          style={{ cursor: 'pointer' }}
                        >
                          <TableCell>
                            <Typography>{metrics.date}</Typography>
                          </TableCell>
                          <TableCell>
                            <Typography>{metrics.services}</Typography>
                          </TableCell>
                          <TableCell>
                            <Typography>{metrics.conversion}%</Typography>
                          </TableCell>
                          <TableCell>
                            <Typography>
                              {metrics.accuracy != null
                                ? `${metrics.accuracy.toFixed(2)}%`
                                : '\u2014'}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )
                    })
                ) : (
                  <TableRow>
                    <TableCell colSpan='4' style={{ textAlign: 'center' }}>
                      {days ? 'Ops, nenhum dia encontrado.' : 'Carregando...'}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        {min ? (
          <Button color='primary' size='small' variant='text'>
            Ver todos <ArrowRightIcon />
          </Button>
        ) : (
          <TablePagination
            component='div'
            count={metadata ? metadata.pagination.totalCount : 0}
            onPageChange={(event, page) => onPageChange(page)}
            onRowsPerPageChange={(event, rows) => onChangeRows(rows)}
            page={metadata ? metadata.pagination.currentPage - 1 : 0}
            rowsPerPage={metadata ? metadata.pagination.limit : 0}
            rowsPerPageOptions={[5, 10, 25]}
          />
        )}
      </CardActions>
    </Card>
  )
}

DaysTable.propTypes = {
  className: PropTypes.string,
  days: PropTypes.array,
  inputsByDate: PropTypes.object,
  min: PropTypes.bool,
  onPageChange: PropTypes.func,
  onChangeRows: PropTypes.func,
  handleSelectDay: PropTypes.func,
  metadata: PropTypes.object
}
